export const SERVICE_ACCOUNT_ID = '00000000-0000-0000-0000-000000000000';

export const ADMIN_NODE_AND_DESCENDANTS = `(
  select child.id
    from public.org_unit child
   where child.full_id like (
     select concat(parent.full_id, '%')
       from public.org_unit parent
      where parent.id = {adminOrgUnitId}
   )
)`;

export const DIRECT_MEMBER_OR_FOLLOWED_NODE_IDS = `(select org_unit_id from public.institution_member where user_id = '{userId}')`;

export const DIRECT_MEMBER_NODE_IDS = `(select org_unit_id from public.institution_member where user_id = '{userId}' and is_verified = true)`;

export const ACCESSIBLE_EVENT_NODE_IDS = `(
  select id from public.event where visibility_limit = 'public'
  union
  select id from public.event where visibility_limit in ('private', 'private-group') and org_unit_id in ${DIRECT_MEMBER_OR_FOLLOWED_NODE_IDS}
  union
  select id from public.event where visibility_limit = 'closed' and org_unit_id in ${ADMIN_NODE_AND_DESCENDANTS}
)`;

export const IS_ME = "id = '{userId}'";

export const EVENTS_I_HAVE_BOOKED = "(select event_id from public.ticket_booking where user_id = '{userId}')";

export const EVENTS_I_HOST = "(select event_id from public.event_host_view where user_id = '{userId}')";

export const EVENTS_I_AM_ADMIN_OF = '(select id from public.event where institution_id = {adminInstitutionId})';

export const GROUPS_I_AM_MEMBER_OF =
  "(select institution_group_id from public.institution_group_member where institution_member_id in (select id from public.institution_member where user_id = '{userId}'))";

export const GROUPS_I_AM_ADMIN_OF =
  '(select id from public.institution_group where institution_id = {adminInstitutionId})';

export const ATTENDEES_OF_EVENT_I_HOST = `(select user_id from public.ticket_booking where event_id IN ${EVENTS_I_HOST})`;

export const MEMBERS_OF_MY_INSTITUTION = `(select user_id from public.institution_member where institution_id = {adminInstitutionId})`;

export const USERS_I_CAN_SEE_USER = `(select '{userId}' UNION select '${SERVICE_ACCOUNT_ID}' UNION ${ATTENDEES_OF_EVENT_I_HOST})`;

export const USERS_I_CAN_SEE_ADMIN = `(select '{userId}' UNION select '${SERVICE_ACCOUNT_ID}' UNION ${ATTENDEES_OF_EVENT_I_HOST} UNION ${MEMBERS_OF_MY_INSTITUTION})`;

export const USERS_I_CAN_UPDATE_USER = "('{userId}')";

export const USERS_I_CAN_UPDATE_ADMIN = `(select '{userId}' UNION ${MEMBERS_OF_MY_INSTITUTION})`;
